module.exports = __webpack_public_path__ + "img/pic7-0.ba84c605.png";